module.exports = __webpack_public_path__ + "static/Appearance-Customization-e6c198ae8ceb83d5794a5c4b231f3c80.png";